
if (!customElements.get("faq-display")) {
  class ComponentFAQDisplay extends HTMLElement {
    constructor() {
      super();
      this.tabsContainer = this.querySelector('.tabs');
      this.accordionsContainer = this.querySelector('.accordions');

      const faqJsons = document.querySelectorAll('[type="application/json"].faq-info');
      this.processJson(faqJsons);

      this.addAnchorEvents();
      this.checkHash();
    }

    processJson(jsonElements) {
      jsonElements.forEach((element) =>{
        const parsedElement = JSON.parse(element.textContent); 
        this.processElement(parsedElement)
      })
    }

    unescapeEntities(str) {
      return str.replace(/&amp;|&lt;|&gt;|&#39;|&quot;/g, tag =>
      ({
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&#39;': "'",
        '&quot;': '"'
      }[tag] || tag))
    }

    processElement(parsedElement) {
      this.setTabButton(parsedElement.key, parsedElement.title);
      this.setAccordions(parsedElement.key, parsedElement.items, parsedElement.title);
    }

    setTabButton(key, title){
      this.tabsContainer.innerHTML += `<div class="btn-container"><button role="tab" aria-selected="true" id="btn-block-${key}" aria-controls="content-block-${key}">${title}</button></div>`;
    }

    setAccordions(key, items, title){
      const accordionsTab = document.createElement("div");
      accordionsTab.id = `content-block-${key}`;
      accordionsTab.setAttribute("aria-labelledby", `btn-block-${key}`);
      accordionsTab.setAttribute("tabindex", "0");
      accordionsTab.setAttribute("role", "tabpanel");
      const h2 = document.createElement("h2");
      h2.setAttribute("class", "client-name h3");
      h2.innerHTML = title;
      accordionsTab.appendChild(h2);
      accordionsTab.appendChild( this.getAccordions(key, items) )
      this.accordionsContainer.appendChild( accordionsTab );
    }

    getAccordions(key, items){
      const utilAccordion = document.createElement("util-accordion");
      utilAccordion.setAttribute("data-expand-multiple","true");
      items.forEach( (item, index) => {
        utilAccordion.appendChild( this.getAccordion(key, item, index) );
      })
      return utilAccordion;
    }

    getAccordion(key, item, index){
      const accordionKey = key + index;
      const accordion = document.createElement("div");
      accordion.className  = "accordion";
      accordion.setAttribute("data-category",accordionKey);
      accordion.innerHTML += `<button aria-expanded="false" class="accordion-trigger" aria-controls="panel-${accordionKey}" id="button-${accordionKey}"><span class="accordion-title">${item.title}</span><span class="accordion-icon"><i></i></span></button>`
      accordion.innerHTML += `<div id="panel-${accordionKey}" role="region" aria-labelledby="button-${accordionKey}" class="body-medium accordion-panel expandable"> ${this.unescapeEntities(item.content)} </div>`;
      return accordion;
    }
    addAnchorEvents(){
      this.querySelectorAll('button[role="tab"]').forEach(
      (element) => {
        element.addEventListener('click', ()=>{
          console.log("element.id",element.id);
          if (history && history.replaceState) {
            history.replaceState(null, '', '#' + element.id);
          } else {
            location.hash = element.id;
          }
          setTimeout(()=>{
            $s.scrollToElement('#faq-anchor', -20 );
          }, 1)
        })
      })
    }
    checkHash(){
      const hash = location.hash;
      console.log(hash);
      setTimeout(()=>{
        if (hash) {
          this.querySelectorAll('button[role="tab"]').forEach((button) => {
            button.setAttribute("aria-selected", "false");
          })
          this.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
            panel.setAttribute("hidden", "hidden");
          })
          const button = document.getElementById(hash.slice(1));
          button.setAttribute("aria-selected", "true");
          const contentID = hash.slice(1).split("btn-block-")[1];
          const panel = document.getElementById(`content-block-${contentID}`);
          panel.removeAttribute("hidden");
          $s.scrollToElement('#faq-anchor', -20 );
        } else {
          console.log("no hash");
        }
      }, 101 )
    }
  }
  customElements.define("faq-display", ComponentFAQDisplay);
}



